// extracted by mini-css-extract-plugin
export default {"container":"CV-z","title":"DV-z","link":"EV-z"};